import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import Label from 'react-bootstrap/lib/Label';


import Link from '../Link';
import Avatar from '../Avatar';
import CurrencyConverter from '../CurrencyConverter';
import MenuItemLink from '../MenuItemLink';

import { sendMessageAction } from '../../actions/message/sendMessageAction';
import { readMessage } from '../../actions/message/readMessage';
import messages from '../../locale/messages';
import { getDateRanges } from '../../helpers/dateRange';

import { EmailIcon, ItineraryIcon, MoreIcon, ReceiptIcon, ReservationPhoneIcon, TripChatIcon, ApproveIcon, MoreDeclineIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';

import s from './Reservation.css';
import { marginBottom } from '../../helpers/getEmailStyles';
const ReservationItem = (props) => {

  const phoneNumberStatus = useSelector(state => state.siteSettings.data.phoneNumberStatus);
  const [smallDevice, setSmallDevice] = useState(false);
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  useEffect(() => {
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      handleResize();
      window.addEventListener('resize', handleResize);
    }
  }, [])

  const handleResize = (e) => {
    let isBrowser = typeof window !== 'undefined';
    let smallDevice = isBrowser ? window.matchMedia('(max-width: 767px)').matches : true;
    setSmallDevice(smallDevice);
  }

  const sendMessage = (type) => {
    const { threadId, checkIn, checkOut, guests, reservationId } = props;
    const { searchKey, currentPage, listIdKey, startDate, endDate, orderBy, dateFilter, userType } = props;
    dispatch(sendMessageAction(threadId, userType, null, type, checkIn, checkOut, guests, reservationId, null, null, null, null, currentPage, searchKey, listIdKey, startDate, endDate, orderBy, dateFilter));
  }

  const reservationStyle = (type) => {
    const { reservationState } = props;
    let style, label;
    switch (reservationState) {
      case 'pending':
        label = <FormattedMessage {...messages.messageStatus5} />
        style = 'primary';
        break;
      case 'expired':
        label = <FormattedMessage {...messages.messageStatus9} />
        style = 'warning';
        break;
      case 'approved':
        label = <FormattedMessage {...messages.messageStatus4} />
        style = 'success';
        break;
      case 'declined':
        label = <FormattedMessage {...messages.messageStatus3} />
        style = 'danger';
        break;
      case 'completed':
        label = <FormattedMessage {...messages.panelHeader2} />
        style = 'success';
        break;
      case 'cancelled':
        label = <FormattedMessage {...messages.messageStatus11} />
        style = 'danger';
        break;
    }
    if (type) {
      return label;
    } else {
      return <Label className={s.labelText} bsStyle={style}>{label}</Label>;
    }
  }

  const paymentLabel = (paymentState, noStyle) => {
		if (!paymentState) return null;
		
		let style, label;
		switch (paymentState) {
			case 'pending':
				label = <FormattedMessage {...messages.paymentStatusPending} />;
				style = 'warning';
				break;
			case 'completed':
				label = <FormattedMessage {...messages.paymentStatusCompleted} />;
				style = 'success';
				break;
			default:
				return null;
		}
		
		if (noStyle) {
			return label;
		}
		return <Label className={cx(s.labelText)} bsStyle={style}>{label}</Label>
	}

  const { threadId, userType, reservationId, reservationState, checkIn, checkOut, createdAt, paymentState } = props;
  const { listId, title, street, city, state, country, zipcode } = props;
  const { profileId, displayName, picture, phoneNumber, countryCode, email, isPhoneVerified } = props;
  const { guestServiceFee, hostServiceFee, total, currency } = props;
  const { noList } = props;
  const { isUserPhotoMigrated } = props;

  let isValue;
  let enableCancel = false, enableIternary = false, enableContactSupport = false, enableGuestReceipt = false;
  let enableApprove = false, enableDecline = false, enableHostReceipt = false;

  if (reservationState == 'completed' || reservationState == 'approved') {
    isValue = '#5cb85c'
  } else if (reservationState == 'expired') {
    isValue = '#f0ad4e'
  } else if (reservationState == 'pending') {
    isValue = '#007bff'
  } else if (reservationState == 'declined' || reservationState == ' cancelled') {
    isValue = '#d9534f'
  }

  let checkInDate = checkIn ? moment(checkIn).format('DD/MM/YYYY') : '';
  let checkOutDate = checkOut ? moment(checkOut).format('DD/MM/YYYY') : '';
  let createdDate = createdAt ? moment(parseInt(createdAt)).format('Do MMM, YYYY') : '';
  let formattedCheckout = moment(checkOut), subTotal = 0;

  const { nights, interval, today } = getDateRanges({ checkIn, checkOut, country })

  if (reservationState === 'approved' && !noList && userType === 'guest') enableIternary = true;
  if (noList) enableContactSupport = true;
  if (!noList && userType === 'guest') enableGuestReceipt = true;
  if (!noList && userType === 'host' && (reservationState === 'approved' || reservationState === 'completed')) enableHostReceipt = true;
  if (!noList && userType === 'host' && reservationState === 'pending') enableApprove = true;
  if (!noList && userType === 'host' && reservationState === 'pending') enableDecline = true;
  if (!noList && reservationState === 'approved' && formattedCheckout > today && (-interval) < (nights - 1)) {
    enableCancel = true;
  }

  if (userType === 'host') {
    // subTotal = total - hostServiceFee;
    subTotal = total;
  } else {
    // subTotal = total + guestServiceFee
    subTotal = total;
  }

  let mailTo = 'mailto:' + email, showPhoneNumber;

  showPhoneNumber = Boolean(countryCode && phoneNumber);

  return (
    <div>
      <div className={cx(s.dateBottom)}>{createdDate}</div>
      <div className={s.reservationItemBox}>
        <div className={s.grid}>
          <div className={s.flex}>
            <div>
              <Avatar
                source={picture}
                height={83}
                width={83}
                title={displayName}
                className={cx(s.profileAvatar, s.profileAvatarLink)}
                withLink={noList ? false : true}
                profileId={profileId}
                isFromMigration={isUserPhotoMigrated}
              />
            </div>
            <div>
              <div> <Link to={"/users/show/" + profileId} className={s.sectionTitleLight}>{displayName}</Link> </div>
              {
                !noList && reservationState && (reservationState === 'approved' || reservationState === 'completed') && <ul className={cx(s.listLayout, 'listLayoutArbic')}>
                  {/* <div className={cx(s.textWordBreak, s.iconFlex)}>
                    <a href={mailTo} className={s.emailFlex}>
                      <EmailIcon className={s.reservationIcon} />
                      <span>{email}</span>
                    </a>
                  </div> */}
                  {showPhoneNumber &&
                    <div className={s.textWordBreak}>
                      <a href={smallDevice && `tel:${countryCode}${phoneNumber}`}>
                        <ReservationPhoneIcon className={s.reservationIcon} />
                        <span>{phoneNumber}</span>
                      </a>
                    </div>
                  }
                </ul>
              }

              {!noList && <div><Link to={"/message/" + threadId + "/" + userType} onClick={() => dispatch(readMessage(threadId, userType))} className={s.chatFlex}>
                <TripChatIcon className={s.reservationIcon} />
                <span><FormattedMessage {...messages.chatText} /></span>
              </Link></div>}
            </div>
          </div>
          <div>
            <div className={cx(s.displayTableCell, s.addressWidth, s.responsiveDisplay, s.tabScreenresolution)}>
              {
                !noList && <div>
                  <a href={"/rooms/" + listId} target={'_blank'} className={s.linkTitle}> {title} </a><br />
                </div>
              }

              {
                noList && userType === 'guest' && <span className={s.errorMessage}> <FormattedMessage {...messages.noList} /> </span>
              }
              {
                noList && userType === 'host' && <span className={s.errorMessage}> <FormattedMessage {...messages.notexist} /> </span>
              }
              {
                !noList && <div>
                  <div className={s.streetCss}>{street}</div>
                  <div className={s.cityCss}>{(city ? `${city}, ` : '')}{(state ? `${state}, ` : '')}{(country ? `${country}, ` : '')}{zipcode} </div>
                </div>
              }
              <div className={s.cityCss}>({checkInDate} - {checkOutDate})</div>
            </div>
          </div>

        </div>
        <div className={s.flexBottom}>
          <div>
            <p className={cx(s.sectionTitleLight, s.spaceTop1)}>
              {reservationStyle()}
            </p>
            <p className={cx(s.sectionTitleLight, s.mt_20)}>
              {paymentLabel(paymentState)}
            </p>
          </div>
          <div className={cx(s.textCenter, s.alignRightMobile, 'alignRightMobileRTL')}>
            <p className={cx(s.space1, s.dateFont)}>
              <CurrencyConverter
                amount={subTotal}
                className={s.bookItPrice}
                from={currency}
              />
            </p>
          </div>
          {(enableContactSupport || enableIternary || enableGuestReceipt || enableHostReceipt || enableApprove || enableDecline || enableCancel) && <div className={cx('tripDropDown', s.textAlignRight, s.textAlignCenterMobile, 'textAlignLeftRtl', 'textAlignCenterMobileRTL')}>
            <DropdownButton
              bsSize="small"
              title={
                <>
                  <MoreIcon className={s.reservationIcon} />
                  {formatMessage(messages.moreText)}
                </>
              }
              id="dropdown-size-small"
              className={s.moreTextSize}
            >
              {enableContactSupport &&
                <MenuItemLink to={"/contact"} className={'svgImg'}>
                  <ReceiptIcon className={s.reservationIcon} />
                  <FormattedMessage {...messages.contactSupport} />
                </MenuItemLink>}
              {enableIternary &&
                <MenuItemLink to={"/users/trips/itinerary/" + reservationId} className={'svgImg'}>
                  <ItineraryIcon className={s.reservationIcon} />
                  <FormattedMessage {...messages.viewItinerary} />
                </MenuItemLink>}

              {enableGuestReceipt &&
                <MenuItemLink to={"/users/trips/receipt/" + reservationId} className={'svgImg'}>
                  <ReceiptIcon className={s.reservationIcon} />
                  <FormattedMessage {...messages.viewReceipt} />
                </MenuItemLink>}

              {enableHostReceipt &&
                <MenuItemLink to={"/users/trips/receipt/" + reservationId} className={'svgImg'}>
                  <ReceiptIcon className={s.reservationIcon} />
                  <FormattedMessage {...messages.viewReceipt} />
                </MenuItemLink>}

              {enableApprove &&
                <MenuItemLink onClick={() => sendMessage('approved')} className={'svgImg'}>
                  <ApproveIcon className={s.reservationIcon} />
                  <FormattedMessage {...messages.approve} />
                </MenuItemLink>}

              {enableDecline &&
                <MenuItemLink onClick={() => sendMessage('declined')} className={'svgImg'}>
                  <MoreDeclineIcon />
                  <FormattedMessage {...messages.decline} />
                </MenuItemLink>}

              {enableCancel &&
                <MenuItemLink to={"/cancel/" + reservationId + "/" + userType} className={'svgImg'}>
                  <MoreDeclineIcon />
                  <FormattedMessage {...messages.cancel} />
                </MenuItemLink>}
            </DropdownButton>
          </div>}
        </div>
      </div>
    </div>
  );
}

ReservationItem.propTypes = {
  noList: PropTypes.bool,
  userType: PropTypes.string.isRequired,
  threadId: PropTypes.number.isRequired,
  reservationId: PropTypes.number.isRequired,
  reservationState: PropTypes.string.isRequired,
  checkIn: PropTypes.string.isRequired,
  checkOut: PropTypes.string.isRequired,
  guests: PropTypes.number.isRequired,
  listId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  street: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  zipcode: PropTypes.string.isRequired,
  profileId: PropTypes.number.isRequired,
  displayName: PropTypes.string.isRequired,
  picture: PropTypes.string,
  guestServiceFee: PropTypes.number.isRequired,
  hostServiceFee: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  sendMessageAction: PropTypes.any.isRequired,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
  formatMessage: PropTypes.any,
  isUserPhotoMigrated: PropTypes.bool,
};

ReservationItem.defaultProps = {
  noList: false,
  checkIn: null,
  checkOut: null
};
export default withStyles(s)(ReservationItem);